import { take, call, put, select, takeEvery } from "redux-saga/effects";
import * as Types from "./constants";
import * as genericTypes from "../../routes/constants";
import axios from "axios";
import Apis from "../../constants/Api";
import history from "../../utilize/history";

function* getCounterSaga({ slug }) {
  let params = {};
  if (localStorage.getItem("aghighToken")) {
    Object.assign(params, {
      headers: {
        Authorization: `token ${localStorage.getItem("aghighToken")}`,
      },
    });
  }
  try {
    const res = yield call(axios.get, Apis.baseUrl + "a/act/banner/", params);
    yield put({
      type: Types.GET_COUNTER_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: genericTypes.TOAST_ERROR,
      payload: { message: error.message },
    });
    yield put({
      type: Types.GET_COUNTER_FAILED,
      payload: { message: error.message },
    });
  }
}

function* setViewBanner({ payload }) {
  try {
    const formData = new FormData();
    formData.append("banner", payload);
    const res = yield call(
      axios.post,
      Apis.baseUrl + "a/act/new-banner-view-log/",
      formData,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.SET_VIEW_BANNER_SUCCESS,
      payload: { ...res.data, id: payload },
    });
  } catch (error) {
    yield put({
      type: genericTypes.TOAST_ERROR,
      payload: { message: error.message },
    });
    yield put({
      type: Types.SET_VIEW_BANNER_FAILED,
      payload: { message: error.message },
    });
  }
}
// Individual exports for testing
export default function* counterSaga() {
  yield takeEvery(Types.GET_COUNTER_REQUESTED, getCounterSaga);
  yield takeEvery(Types.SET_VIEW_BANNER_REQUESTED, setViewBanner);
}
